import React from "react"

export const contactList = ({ style }) => (
  <svg
    style={style}
    width="99px"
    height="87px"
    viewBox="0 0 99 87"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Landing-Page-Copy"
        transform="translate(-341.000000, -1897.000000)">
        <g id="Feature-Set" transform="translate(258.000000, 1753.000000)">
          <g
            id="Contact-List---Feature-Set"
            transform="translate(83.000000, 141.000000)">
            <g id="Group-30" transform="translate(0.000000, 3.000000)">
              <path
                d="M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z"
                id="Rectangle-19-Copy-18"
                fill="#B6BFF3"
              />
              <path
                d="M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z"
                id="Rectangle-19-Copy-19"
                stroke="#222232"
                strokeWidth="2"
              />
              <g id="Group-29" transform="translate(29.000000, 19.000000)">
                <rect
                  id="Rectangle-46"
                  fill="#F7F7F9"
                  x="0"
                  y="1"
                  width="38"
                  height="20"
                  rx="3"
                />
                <path
                  d="M5,6.99620141 L19.2008109,15.791534 L19.2008109,15.791534 C19.8487274,16.1928238 20.6683959,16.1910037 21.3145239,15.7868405 L34.2876306,7.67195665"
                  id="Path-20-Copy"
                  stroke="#9192C5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transform="translate(19.643815, 11.543719) scale(1, -1) translate(-19.643815, -11.543719) "
                />
                <polygon
                  id="Path-20"
                  fill="#D6D6E0"
                  points="2 1 20.2030714 12 38 1"
                />
                <path
                  d="M8.50250442,5.08816214 L19.2164965,11.5927557 L19.2164965,11.5927557 C19.8567472,11.9814596 20.6605226,11.9798422 21.2992038,11.5885648 L36.9524628,1.99885639"
                  id="Path-20"
                  stroke="#222232"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <rect
                  id="Rectangle-46"
                  stroke="#222232"
                  strokeWidth="2"
                  x="2"
                  y="1"
                  width="36"
                  height="18"
                  rx="3"
                />
              </g>
              <g id="Group-29" transform="translate(46.000000, 33.000000)">
                <rect
                  id="Rectangle-46"
                  fill="#F7F7F9"
                  x="0"
                  y="1"
                  width="38"
                  height="20"
                  rx="3"
                />
                <path
                  d="M5,6.99620141 L19.2008109,15.791534 L19.2008109,15.791534 C19.8487274,16.1928238 20.6683959,16.1910037 21.3145239,15.7868405 L34.2876306,7.67195665"
                  id="Path-20-Copy"
                  stroke="#9192C5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transform="translate(19.643815, 11.543719) scale(1, -1) translate(-19.643815, -11.543719) "
                />
                <polygon
                  id="Path-20"
                  fill="#D6D6E0"
                  points="2 1 20.2030714 12 38 1"
                />
                <path
                  d="M7.73975993,4.53278256 L19.2144213,11.5837929 L19.2144213,11.5837929 C19.8554502,11.9776957 20.6633077,11.978514 21.3051333,11.5859106 L36.9290487,2.02879332"
                  id="Path-20"
                  stroke="#222232"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <rect
                  id="Rectangle-46"
                  stroke="#222232"
                  strokeWidth="2"
                  x="2"
                  y="1"
                  width="36"
                  height="18"
                  rx="3"
                />
              </g>
              <g id="Group-29" transform="translate(23.000000, 44.000000)">
                <rect
                  id="Rectangle-46"
                  fill="#F7F7F9"
                  x="0"
                  y="1"
                  width="38"
                  height="20"
                  rx="3"
                />
                <path
                  d="M5,6.99620141 L19.2008109,15.791534 L19.2008109,15.791534 C19.8487274,16.1928238 20.6683959,16.1910037 21.3145239,15.7868405 L34.2876306,7.67195665"
                  id="Path-20-Copy"
                  stroke="#9192C5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transform="translate(19.643815, 11.543719) scale(1, -1) translate(-19.643815, -11.543719) "
                />
                <polygon
                  id="Path-20"
                  fill="#D6D6E0"
                  points="2 1 20.2030714 12 38 1"
                />
                <path
                  d="M8.58458475,5.12960041 L19.207944,11.5868076 L19.207944,11.5868076 C19.8526403,11.978674 20.6629903,11.9744053 21.3035225,11.5757686 L36.6980868,1.99492494"
                  id="Path-20"
                  stroke="#222232"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <rect
                  id="Rectangle-46"
                  stroke="#222232"
                  strokeWidth="2"
                  x="2"
                  y="1"
                  width="36"
                  height="18"
                  rx="3"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const easyInstall = ({ style }) => (
  <svg
    style={style}
    width="99px"
    height="87px"
    viewBox="0 0 99 87"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Landing-Page-Copy"
        transform="translate(-340.000000, -2030.000000)">
        <g id="Feature-Set" transform="translate(258.000000, 1753.000000)">
          <g
            id="Easy-Install---Feature-Set"
            transform="translate(82.000000, 275.000000)">
            <g id="Group-31" transform="translate(0.000000, 2.000000)">
              <path
                d="M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z"
                id="Rectangle-19-Copy-9"
                fill="#B6BFF3"
              />
              <path
                d="M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z"
                id="Rectangle-19-Copy-10"
                stroke="#222232"
                strokeWidth="2"
              />
              <path
                d="M25.391114,42.2440523 L23.6079109,42.8670991 L24.6606453,43.2967866 L37.0117188,48.8183691 L37.0117188,53.8278222 L18.4086921,45.5189894 L18.4086921,40.224521 L37.0117188,32.0148441 L37.0117188,37.7640632 L25.391114,42.2440523 Z M46.0390625,58.6855469 L40.4101562,58.6855469 L54.6282403,24.71875 L60.2786309,24.71875 L46.0390625,58.6855469 Z M63.8233095,37.9230472 L63.8233095,32.0148441 L81.9199219,40.0800781 L81.9199219,44.8925781 L63.8233095,53.2953264 L63.8233095,47.0968754 L74.3359375,43.0019531 L75.9472656,42.5078125 L75.0449219,42.1425781 L63.8233095,37.9230472 Z"
                id="&lt;-/-&gt;"
                fill="#F7F7F9"
              />
              <path
                d="M22.4882812,41.90625 L37.9785156,48.3515625 L37.9785156,51.0585938 L19.5664062,42.9160156 L19.5664062,40.8535156 L37.9785156,32.7324219 L37.9785156,35.4179688 L22.4882812,41.90625 Z M47.2089844,58.6855469 L44.8027344,58.6855469 L57.8652344,24.71875 L60.2714844,24.71875 L47.2089844,58.6855469 Z M81.3398438,41.8203125 L65.5488281,35.3320312 L65.5488281,32.6894531 L84.3261719,40.8105469 L84.3261719,42.8730469 L65.5488281,51.015625 L65.5488281,48.3730469 L81.3398438,41.8203125 Z"
                id="&lt;-/-&gt;"
                fill="#000000"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const customizable = ({ style }) => (
  <svg
    style={style}
    width="99px"
    height="87px"
    viewBox="0 0 99 87"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Landing-Page-Copy"
        transform="translate(-340.000000, -2161.000000)">
        <g id="Feature-Set" transform="translate(258.000000, 1753.000000)">
          <g
            id="Customizable---Feature-Set"
            transform="translate(82.000000, 406.000000)">
            <g id="Group-32" transform="translate(0.000000, 2.000000)">
              <path
                d="M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z"
                id="Rectangle-19-Copy-20"
                fill="#B6BFF3"
              />
              <path
                d="M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z"
                id="Rectangle-19-Copy-21"
                stroke="#222232"
                strokeWidth="2"
              />
              <g
                id="Customizable---Feature-Set"
                transform="translate(28.000000, 28.000000)"
                stroke="#FFFFFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M0,1.5 L50,1.5" id="Line-12-Copy-3" />
              </g>
              <path
                d="M28,41.5 L78,41.5"
                id="Line-12-Copy-4"
                stroke="#FFFFFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M28,53.5 L78,53.5"
                id="Line-12-Copy-5"
                stroke="#FFFFFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M71.5,54.5 L52.5,54.5"
                id="Line-13-Copy-3"
                stroke="#222232"
                strokeLinecap="round"
              />
              <path
                d="M48.5,42.5 L29.5,42.5"
                id="Line-13-Copy-4"
                stroke="#222232"
                strokeLinecap="round"
              />
              <path
                d="M49.5,30.5 L30.5,30.5"
                id="Line-13-Copy-5"
                stroke="#222232"
                strokeLinecap="round"
              />
              <circle
                id="Oval-13-Copy-3"
                fill="#F7F7F9"
                cx="44"
                cy="29"
                r="4"
              />
              <circle
                id="Oval-13-Copy-4"
                fill="#F7F7F9"
                cx="36"
                cy="41"
                r="4"
              />
              <circle
                id="Oval-13-Copy-5"
                fill="#F7F7F9"
                cx="70"
                cy="53"
                r="4"
              />
              <circle
                id="Oval-13-Copy-6"
                fill="#9192C5"
                cx="42"
                cy="30"
                r="4"
              />
              <circle
                id="Oval-13-Copy-7"
                fill="#9192C5"
                cx="34"
                cy="42"
                r="4"
              />
              <circle
                id="Oval-13-Copy-8"
                fill="#9192C5"
                cx="68"
                cy="54"
                r="4"
              />
              <circle
                id="Oval-13-Copy-9"
                stroke="#222232"
                strokeWidth="2"
                cx="44"
                cy="29"
                r="4"
              />
              <circle
                id="Oval-13-Copy-10"
                stroke="#222232"
                strokeWidth="2"
                cx="36"
                cy="41"
                r="4"
              />
              <circle
                id="Oval-13-Copy-11"
                stroke="#222232"
                strokeWidth="2"
                cx="70"
                cy="53"
                r="4"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const autoMessages = ({ style }) => (
  <svg
    style={style}
    width="99px"
    height="87px"
    viewBox="0 0 99 87"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Landing-Page-Copy"
        transform="translate(-855.000000, -1899.000000)">
        <g id="Feature-Set" transform="translate(258.000000, 1753.000000)">
          <g
            id="Auto-Message---Feature-Set"
            transform="translate(597.000000, 141.000000)">
            <g id="Group-32" transform="translate(0.000000, 5.000000)">
              <path
                d="M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z"
                id="Rectangle-19-Copy-20"
                fill="#B6BFF3"
              />
              <path
                d="M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z"
                id="Rectangle-19-Copy-21"
                stroke="#222232"
                strokeWidth="2"
              />
              <g id="Group-22-Copy" transform="translate(18.000000, 21.000000)">
                <ellipse
                  id="Oval-11"
                  fill="#EBECEF"
                  cx="20.5"
                  cy="19"
                  rx="20.5"
                  ry="18"
                />
                <path
                  d="M11.9995947,40 L18.022421,36.0761035 C20.058443,36.6878675 22.2363762,37.0191304 24.5,37.0191304 C35.8218374,37.0191304 45,28.7321158 45,18.5095652 C45,8.28701461 35.8218374,0 24.5,0 C22.9753566,0 21.4895874,0.150279875 20.059871,0.435329014 C16.0319188,1.2384004 12.44887,3.11116611 9.69486511,5.70678375 C8.76116213,6.58678796 7.92275315,7.54988 7.19460818,8.58254336 C5.17184446,11.4512496 4,14.8568452 4,18.5095652 C4,24.0337041 6.68019502,28.9926303 10.9305199,32.3840599"
                  id="Combined-Shape"
                  stroke="#222232"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <ellipse
                  id="Oval-11"
                  fill="#FFFFFF"
                  cx="39.5"
                  cy="25"
                  rx="20.5"
                  ry="18"
                />
                <path
                  d="M29.9995947,47 L36.022421,43.0761035 C38.058443,43.6878675 40.2363762,44.0191304 42.5,44.0191304 C53.8218374,44.0191304 63,35.7321158 63,25.5095652 C63,15.2870146 53.8218374,7 42.5,7 C40.9753566,7 39.4895874,7.15027988 38.059871,7.43532901 C34.0319188,8.2384004 30.44887,10.1111661 27.6948651,12.7067838 C26.7611621,13.586788 25.9227532,14.54988 25.1946082,15.5825434 C23.1718445,18.4512496 22,21.8568452 22,25.5095652 C22,31.0337041 24.680195,35.9926303 28.9305199,39.3840599"
                  id="Combined-Shape-Copy-2"
                  stroke="#222232"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transform="translate(42.500000, 27.000000) scale(-1, 1) translate(-42.500000, -27.000000) "
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const editMessages = ({ style }) => (
  <svg
    style={style}
    width="99px"
    height="87px"
    viewBox="0 0 99 87"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Landing-Page-Copy"
        transform="translate(-857.000000, -2030.000000)">
        <g id="Feature-Set" transform="translate(258.000000, 1753.000000)">
          <g
            id="Message-Editing---Feature-Set"
            transform="translate(599.000000, 275.000000)">
            <g id="Group-32" transform="translate(0.000000, 2.000000)">
              <path
                d="M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z"
                id="Rectangle-19-Copy-20"
                fill="#B6BFF3"
              />
              <path
                d="M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z"
                id="Rectangle-19-Copy-21"
                stroke="#222232"
                strokeWidth="2"
              />
              <g id="Group-22-Copy" transform="translate(28.000000, 18.000000)">
                <ellipse
                  id="Oval-11-Copy"
                  fill="#FFFFFF"
                  cx="20.5"
                  cy="26"
                  rx="20.5"
                  ry="18"
                />
                <path
                  d="M10.9995947,48 L17.022421,44.0761035 C19.058443,44.6878675 21.2363762,45.0191304 23.5,45.0191304 C34.8218374,45.0191304 44,36.7321158 44,26.5095652 C44,16.2870146 34.8218374,8 23.5,8 C21.9753566,8 20.4895874,8.15027988 19.059871,8.43532901 C15.0319188,9.2384004 11.44887,11.1111661 8.69486511,13.7067838 C7.76116213,14.586788 6.92275315,15.54988 6.19460818,16.5825434 C4.17184446,19.4512496 3,22.8568452 3,26.5095652 C3,32.0337041 5.68019502,36.9926303 9.93051993,40.3840599"
                  id="Combined-Shape-Copy-3"
                  stroke="#222232"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transform="translate(23.500000, 28.000000) scale(-1, 1) translate(-23.500000, -28.000000) "
                />
                <path
                  d="M32.4767288,-0.221782976 L34.6019832,-0.39688284 L34.6019832,-0.39688284 C36.2532425,-0.532930207 37.7021408,0.695391721 37.8381881,2.34665097 C37.8413529,2.3850627 37.8437771,2.42353185 37.8454594,2.46203699 L38.6899618,21.7907998 L34.9235178,28.3564521 L34.9235178,28.3564521 C34.6487028,28.8355087 34.0375691,29.0010792 33.5585126,28.7262642 C33.41106,28.6416767 33.2876046,28.5208965 33.1998077,28.375332 L30.2978587,23.5639933 L30.2978587,23.5639933 C29.9218045,22.9405075 29.7230643,22.2262025 29.7230643,21.4980876 L29.7230643,2.76808638 L29.7230643,2.76808638 C29.7230643,1.20674101 30.9206559,-0.0935780198 32.4767288,-0.221782976 Z"
                  id="Rectangle-9"
                  fill="#9192C5"
                  transform="translate(34.206513, 14.225924) rotate(-315.000000) translate(-34.206513, -14.225924) "
                />
                <g
                  id="pencil"
                  transform="translate(22.000000, 0.000000)"
                  stroke="#222232">
                  <g
                    id="Group-7-Copy"
                    transform="translate(13.849242, 13.849242) rotate(-225.000000) translate(-13.849242, -13.849242) translate(-1.150758, 9.849242)">
                    <rect
                      id="Rectangle-19"
                      strokeWidth="2"
                      x="5.53713536"
                      y="1"
                      width="16.9047307"
                      height="5.56189227"
                    />
                    <path
                      d="M23.9675791,6.56189227 L28.4494334,3.91657194 C28.7524791,3.73770562 28.7525398,3.77965392 28.4525808,3.60266868 L24.0415131,1 L3.79858159,1 C2.25841341,1 1.01514008,2.24347728 1.01514008,3.78094613 C1.01514008,5.31395832 2.26352253,6.56189227 3.80038106,6.56189227 L23.9675791,6.56189227 Z"
                      id="Rectangle-19-Copy-2"
                      strokeWidth="2"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const analytics = ({ style }) => (
  <svg
    style={style}
    width="98px"
    height="85px"
    viewBox="0 0 98 85"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="2" fill="none" fillRule="evenodd">
      <g
        id="Landing-Page-Copy"
        transform="translate(-856.000000, -2162.000000)">
        <g id="Feature-Set" transform="translate(258.000000, 1753.000000)">
          <g
            id="Analytics---Feature-Set"
            transform="translate(598.000000, 406.000000)">
            <g id="Group-23" transform="translate(0.000000, 3.000000)">
              <path
                d="M24.4905599,4.58447451 L27.4417745,3.75596891 L27.4417745,3.75596891 C40.5033442,0.0891452598 54.3211933,0.0806289737 67.3872731,3.7313495 L70.5962402,4.62794914 L70.5962402,4.62794914 C81.1401053,7.57395173 89.4297989,15.732231 92.5438992,26.2276777 L92.5697889,26.3149337 L92.5697889,26.3149337 C95.8182862,37.2633383 95.8092903,48.9206435 92.5438992,59.8640212 L92.5438992,59.8640212 L92.5438992,59.8640212 C89.429237,70.3022582 81.1745416,78.410983 70.6824013,81.3389349 L67.3168622,82.2781272 L67.3168622,82.2781272 C54.2645817,85.9205156 40.4625522,85.9075932 27.4171151,82.2407705 L24.240531,81.3478935 L24.240531,81.3478935 C13.7988698,78.4129424 5.58444466,70.3402119 2.46827125,59.9511941 L2.46827125,59.9511941 L2.46827125,59.9511941 C-0.797112839,49.0647225 -0.822504615,37.4630716 2.39519539,26.5624109 L2.46827125,26.3148505 L2.46827125,26.3148505 C5.58229344,15.7654211 13.9005186,7.55745666 24.4905599,4.58447451 Z"
                id="Rectangle-19-Copy-16"
                fill="#B6BFF3"
              />
              <path
                d="M27.7608448,4.54725488 C17.5020342,7.42724943 9.44398265,15.3784888 6.42735945,25.597958 L6.3542836,25.8455184 C3.19155442,36.5599534 3.21651241,47.9634029 6.42611103,58.6638912 C9.4439219,68.7249779 17.3990573,76.5428913 27.5111257,79.3852002 L30.6877098,80.2780772 C43.5567917,83.8953298 57.1722379,83.9080774 70.0480707,80.3149288 L73.4136097,79.3757366 C83.5748535,76.5401251 91.5692159,68.6871297 94.5856493,58.5780893 C97.7955238,47.8207653 97.8043668,36.3616517 94.6110988,25.5993863 L94.5852091,25.5121303 C91.5689534,15.346449 83.5397207,7.44450158 73.3271423,4.59106195 L70.1181751,3.69446231 C57.2285263,0.0930373555 43.5972592,0.101438646 30.7120595,3.71874928 L27.7608448,4.54725488 Z"
                id="Rectangle-19-Copy-17"
                stroke="#222232"
                strokeWidth="2"
              />
              <g id="Group-28" transform="translate(25.000000, 25.000000)">
                <rect
                  id="Rectangle-45"
                  fill="#FFFFFF"
                  x="0"
                  y="3"
                  width="50"
                  height="30"
                  rx="3"
                />
                <path
                  d="M3.69324136,28.8950601 L9.11019346,19.3409746 L9.11019346,19.3409746 C9.65498621,18.3801028 10.8755685,18.0428041 11.8364403,18.5875968 C11.8411173,18.5902486 11.8457836,18.5929191 11.850439,18.5956085 L15.5241629,20.7178594 L15.5241629,20.7178594 C17.0468352,21.5974826 18.9654005,21.3794974 20.2519247,20.1806966 L26.0935078,14.7374293 L26.0935078,14.7374293 C26.6940211,14.1778628 27.5754617,14.0420176 28.3165859,14.3948147 L33.0555244,16.6506897 L33.0555244,16.6506897 C34.2818599,17.2344617 35.7206363,17.1560665 36.8762835,16.4425064 L48.9298034,9 L48.9298034,29.8814947 L48.9298034,29.8814947 C48.9298034,30.9860642 48.0343729,31.8814947 46.9298034,31.8814947 L5.43305368,31.8814947 L5.43305368,31.8814947 C4.32848418,31.8814947 3.43305368,30.9860642 3.43305368,29.8814947 C3.43305368,29.5357199 3.52269929,29.1958517 3.69324136,28.8950601 Z"
                  id="Path-4"
                  fill="#EBECEF"
                />
                <path
                  d="M2.91741078,30.2302125 L12.1588613,17.8788385 L12.1588613,17.8788385 C12.4207982,17.5287548 12.8798004,17.3894323 13.2921388,17.5348509 L20.1018015,19.9364007 L20.1018015,19.9364007 C20.8006688,20.1828688 21.5785318,20.0227064 22.1231842,19.520197 L28.9214226,13.2479787 L28.9214226,13.2479787 C29.2362683,12.9574945 29.7011647,12.8998146 30.0774523,13.1045497 L35.9705581,16.3109404 L35.9705581,16.3109404 C36.7187632,16.7180327 37.6427079,16.6065721 38.2726375,16.0332279 L46,9"
                  id="Path-4"
                  stroke="#9192C5"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M2,8 L2,28.3057804 L2,28.3057804 C2,29.9626346 3.34314575,31.3057804 5,31.3057804 L42.9338268,31.3057804"
                  id="Path-19"
                  stroke="#222232"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M38.8107389,-3.55271368e-15 L38.8107389,12.6460872 L38.8107389,12.6460872 C38.8107389,14.3029415 40.1538847,15.6460872 41.8107389,15.6460872 L52.9338268,15.6460872"
                  id="Path-19-Copy"
                  stroke="#222232"
                  strokeWidth="2"
                  strokeLinecap="round"
                  transform="translate(45.872283, 7.823044) scale(-1, -1) translate(-45.872283, -7.823044) "
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const slack = ({ style }) => (
  <svg
    style={style}
    width="99px"
    height="87px"
    viewBox="0 0 99 87"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-598.000000, -511.000000)">
        <g id="Group-31-Copy" transform="translate(598.000000, 511.000000)">
          <g id="Group-42">
            <path
              d="M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z"
              id="Rectangle-19-Copy-9"
              fill="#B6BFF3"
            />
            <path
              d="M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z"
              id="Rectangle-19-Copy-10"
              stroke="#222232"
              strokeWidth="2"
            />
            <g
              id="slack"
              transform="translate(25.000000, 19.000000)"
              fillRule="nonzero">
              <path
                d="M17.4126232,24.6244729 L20.5824922,33.405262 L30.0382807,30.2952024 L26.8684116,21.5144133 L17.4126232,24.6244729 Z M14.9833728,17.8952564 L24.4391612,14.7851967 L22.265216,8.76319578 C21.5946306,6.90562108 22.5855351,4.86519279 24.4784631,4.20577164 C26.3713911,3.54635049 28.4495293,4.51764584 29.1201146,6.37522054 L31.337094,12.5164295 L36.8299735,10.709792 C38.7341217,10.0835074 40.7949919,11.0909233 41.433056,12.9599184 C42.0711201,14.8289135 41.0447561,16.8517374 39.1406079,17.478022 L33.7663444,19.2456461 L36.9362135,28.0264352 L42.2075103,26.2926774 C44.1116584,25.6663928 46.1725287,26.6738087 46.8105927,28.5428038 C47.4486568,30.411799 46.4222928,32.4346228 44.5181447,33.0609074 L39.3654639,34.7556518 L41.2165183,39.8832195 C41.8871036,41.7407942 40.8961991,43.7812225 39.0032711,44.4406436 C37.1103431,45.1000648 35.032205,44.1287694 34.3616196,42.2711947 L32.4675311,37.024419 L23.0117426,40.1344786 L24.8536846,45.2368042 C25.52427,47.0943789 24.5333655,49.1348072 22.6404375,49.7942284 C20.7475095,50.4536495 18.6693713,49.4823542 17.998786,47.6247795 L16.1138098,42.4032458 L10.1700265,44.3581881 C8.2658783,44.9844726 6.20500808,43.9770567 5.56694401,42.1080616 C4.92887993,40.2390665 5.9552439,38.2162426 7.85939208,37.5899581 L13.6845594,35.6740292 L10.5146903,26.8932401 L4.79248973,28.7753026 C2.88834155,29.4015872 0.827471333,28.3941713 0.189407261,26.5251762 C-0.44865681,24.6561811 0.577707151,22.6333572 2.48185533,22.0070726 L8.08543994,20.1640235 L5.90238232,14.1167805 C5.23179697,12.2592058 6.22270147,10.2187775 8.11562947,9.55935639 C10.0085575,8.89993524 12.0866956,9.8712306 12.757281,11.7288053 L14.9833728,17.8952564 Z"
                id="Combined-Shape"
                fill="#9192C5"
              />
              <path
                d="M20.4126232,21.6244729 L23.5824922,30.405262 L33.0382807,27.2952024 L29.8684116,18.5144133 L20.4126232,21.6244729 Z M17.9833728,14.8952564 L27.4391612,11.7851967 L25.265216,5.76319578 C24.5946306,3.90562108 25.5855351,1.86519279 27.4784631,1.20577164 C29.3713911,0.546350487 31.4495293,1.51764584 32.1201146,3.37522054 L34.337094,9.51642955 L39.8299735,7.70979196 C41.7341217,7.08350739 43.7949919,8.09092332 44.433056,9.95991843 C45.0711201,11.8289135 44.0447561,13.8517374 42.1406079,14.478022 L36.7663444,16.2456461 L39.9362135,25.0264352 L45.2075103,23.2926774 C47.1116584,22.6663928 49.1725287,23.6738087 49.8105927,25.5428038 C50.4486568,27.411799 49.4222928,29.4346228 47.5181447,30.0609074 L42.3654639,31.7556518 L44.2165183,36.8832195 C44.8871036,38.7407942 43.8961991,40.7812225 42.0032711,41.4406436 C40.1103431,42.1000648 38.032205,41.1287694 37.3616196,39.2711947 L35.4675311,34.024419 L26.0117426,37.1344786 L27.8536846,42.2368042 C28.52427,44.0943789 27.5333655,46.1348072 25.6404375,46.7942284 C23.7475095,47.4536495 21.6693713,46.4823542 20.998786,44.6247795 L19.1138098,39.4032458 L13.1700265,41.3581881 C11.2658783,41.9844726 9.20500808,40.9770567 8.56694401,39.1080616 C7.92887993,37.2390665 8.9552439,35.2162426 10.8593921,34.5899581 L16.6845594,32.6740292 L13.5146903,23.8932401 L7.79248973,25.7753026 C5.88834155,26.4015872 3.82747133,25.3941713 3.18940726,23.5251762 C2.55134319,21.6561811 3.57770715,19.6333572 5.48185533,19.0070726 L11.0854399,17.1640235 L8.90238232,11.1167805 C8.23179697,9.25920583 9.22270147,7.21877755 11.1156295,6.55935639 C13.0085575,5.89993524 15.0866956,6.8712306 15.757281,8.72880529 L17.9833728,14.8952564 Z"
                id="Combined-Shape"
                fill="#2C2C46"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const unlimited = ({ style }) => (
  <svg
    width="99px"
    height="87px"
    viewBox="0 0 99 87"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-714.000000, -511.000000)">
        <g id="Group-49" transform="translate(714.000000, 511.000000)">
          <g id="Group-31-Copy-2">
            <path
              d="M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z"
              id="Rectangle-19-Copy-9"
              fill="#B6BFF3"
            />
            <path
              d="M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z"
              id="Rectangle-19-Copy-10"
              stroke="#222232"
              strokeWidth="2"
            />
          </g>
          <g id="Group-41" transform="translate(24.000000, 26.000000)">
            <path
              d="M6.5775,30.735 C4.54082315,29.3483264 3.02417165,27.5608443 2.0275,25.3725 C1.03082835,23.1841557 0.5325,20.8550123 0.5325,18.385 C0.5325,15.9149876 1.03082835,13.5858443 2.0275,11.3975 C3.02417165,9.20915572 4.54082315,7.4216736 6.5775,6.035 C8.61417685,4.6483264 11.1058186,3.955 14.0525,3.955 C16.652513,3.955 18.8949906,4.63749317 20.78,6.0025 C22.6650094,7.36750682 24.5824902,9.3066541 26.5325,11.82 C28.4391762,9.34998765 30.3349906,7.4216736 32.22,6.035 C34.1050094,4.6483264 36.3258206,3.955 38.8825,3.955 C41.8725149,3.955 44.3858231,4.6483264 46.4225,6.035 C48.4591768,7.4216736 49.9758284,9.20915572 50.9725,11.3975 C51.9691717,13.5858443 52.4675,15.9149876 52.4675,18.385 C52.4675,20.8550123 51.9691717,23.1841557 50.9725,25.3725 C49.9758284,27.5608443 48.4591768,29.3483264 46.4225,30.735 C44.3858231,32.1216736 41.8941814,32.815 38.9475,32.815 C36.347487,32.815 34.0941762,32.14334 32.1875,30.8 C30.2808238,29.4566599 28.3741762,27.5716788 26.4675,25.145 C24.6041574,27.5716788 22.7191762,29.4566599 20.8125,30.8 C18.9058238,32.14334 16.652513,32.815 14.0525,32.815 C11.1058186,32.815 8.61417685,32.1216736 6.5775,30.735 Z M18.5375,22.675 C19.88084,21.2883264 20.8991632,19.9016736 21.5925,18.515 C20.8124961,17.0416593 19.7616733,15.5900071 18.44,14.16 C17.1183267,12.7299928 15.7208407,12.015 14.2475,12.015 C12.7741593,12.015 11.506672,12.5891609 10.445,13.7375 C9.38332802,14.8858391 8.8525,16.4349902 8.8525,18.385 C8.8525,20.3350097 9.38332802,21.8841609 10.445,23.0325 C11.506672,24.1808391 12.7741593,24.755 14.2475,24.755 C15.7641742,24.755 17.1941599,24.0616736 18.5375,22.675 Z M42.49,23.0325 C43.551672,21.8841609 44.0825,20.3350097 44.0825,18.385 C44.0825,16.4349902 43.551672,14.8858391 42.49,13.7375 C41.428328,12.5891609 40.1825071,12.015 38.7525,12.015 C37.2358258,12.015 35.7950068,12.7408261 34.43,14.1925 C33.0649932,15.6441739 32.0358368,17.0849928 31.3425,18.515 C32.0791704,19.9016736 33.11916,21.2883264 34.4625,22.675 C35.8058401,24.0616736 37.2358258,24.755 38.7525,24.755 C40.1825071,24.755 41.428328,24.1808391 42.49,23.0325 Z"
              id="∞"
              fill="#9192C5"
            />
            <path
              d="M8.5775,27.735 C6.54082315,26.3483264 5.02417165,24.5608443 4.0275,22.3725 C3.03082835,20.1841557 2.5325,17.8550123 2.5325,15.385 C2.5325,12.9149876 3.03082835,10.5858443 4.0275,8.3975 C5.02417165,6.20915572 6.54082315,4.4216736 8.5775,3.035 C10.6141769,1.6483264 13.1058186,0.955 16.0525,0.955 C18.652513,0.955 20.8949906,1.63749317 22.78,3.0025 C24.6650094,4.36750682 26.5824902,6.3066541 28.5325,8.82 C30.4391762,6.34998765 32.3349906,4.4216736 34.22,3.035 C36.1050094,1.6483264 38.3258206,0.955 40.8825,0.955 C43.8725149,0.955 46.3858231,1.6483264 48.4225,3.035 C50.4591768,4.4216736 51.9758284,6.20915572 52.9725,8.3975 C53.9691717,10.5858443 54.4675,12.9149876 54.4675,15.385 C54.4675,17.8550123 53.9691717,20.1841557 52.9725,22.3725 C51.9758284,24.5608443 50.4591768,26.3483264 48.4225,27.735 C46.3858231,29.1216736 43.8941814,29.815 40.9475,29.815 C38.347487,29.815 36.0941762,29.14334 34.1875,27.8 C32.2808238,26.4566599 30.3741762,24.5716788 28.4675,22.145 C26.6041574,24.5716788 24.7191762,26.4566599 22.8125,27.8 C20.9058238,29.14334 18.652513,29.815 16.0525,29.815 C13.1058186,29.815 10.6141769,29.1216736 8.5775,27.735 Z M20.5375,19.675 C21.88084,18.2883264 22.8991632,16.9016736 23.5925,15.515 C22.8124961,14.0416593 21.7616733,12.5900071 20.44,11.16 C19.1183267,9.72999285 17.7208407,9.015 16.2475,9.015 C14.7741593,9.015 13.506672,9.58916092 12.445,10.7375 C11.383328,11.8858391 10.8525,13.4349902 10.8525,15.385 C10.8525,17.3350097 11.383328,18.8841609 12.445,20.0325 C13.506672,21.1808391 14.7741593,21.755 16.2475,21.755 C17.7641742,21.755 19.1941599,21.0616736 20.5375,19.675 Z M44.49,20.0325 C45.551672,18.8841609 46.0825,17.3350097 46.0825,15.385 C46.0825,13.4349902 45.551672,11.8858391 44.49,10.7375 C43.428328,9.58916092 42.1825071,9.015 40.7525,9.015 C39.2358258,9.015 37.7950068,9.74082607 36.43,11.1925 C35.0649932,12.6441739 34.0358368,14.0849928 33.3425,15.515 C34.0791704,16.9016736 35.11916,18.2883264 36.4625,19.675 C37.8058401,21.0616736 39.2358258,21.755 40.7525,21.755 C42.1825071,21.755 43.428328,21.1808391 44.49,20.0325 Z"
              id="∞"
              fill="#F7F7F9"
            />
            <path
              d="M8.5775,27.735 C6.54082315,26.3483264 5.02417165,24.5608443 4.0275,22.3725 C3.03082835,20.1841557 2.5325,17.8550123 2.5325,15.385 C2.5325,12.9149876 3.03082835,10.5858443 4.0275,8.3975 C5.02417165,6.20915572 6.54082315,4.4216736 8.5775,3.035 C10.6141769,1.6483264 13.1058186,0.955 16.0525,0.955 C18.652513,0.955 20.8949906,1.63749317 22.78,3.0025 C24.6650094,4.36750682 26.5824902,6.3066541 28.5325,8.82 C30.4391762,6.34998765 32.3349906,4.4216736 34.22,3.035 C36.1050094,1.6483264 38.3258206,0.955 40.8825,0.955 C43.8725149,0.955 46.3858231,1.6483264 48.4225,3.035 C50.4591768,4.4216736 51.9758284,6.20915572 52.9725,8.3975 C53.9691717,10.5858443 54.4675,12.9149876 54.4675,15.385 C54.4675,17.8550123 53.9691717,20.1841557 52.9725,22.3725 C51.9758284,24.5608443 50.4591768,26.3483264 48.4225,27.735 C46.3858231,29.1216736 43.8941814,29.815 40.9475,29.815 C38.347487,29.815 36.0941762,29.14334 34.1875,27.8 C32.2808238,26.4566599 30.3741762,24.5716788 28.4675,22.145 C26.6041574,24.5716788 24.7191762,26.4566599 22.8125,27.8 C20.9058238,29.14334 18.652513,29.815 16.0525,29.815 C13.1058186,29.815 10.6141769,29.1216736 8.5775,27.735 Z M20.5375,19.675 C21.88084,18.2883264 22.8991632,16.9016736 23.5925,15.515 C22.8124961,14.0416593 21.7616733,12.5900071 20.44,11.16 C19.1183267,9.72999285 17.7208407,9.015 16.2475,9.015 C14.7741593,9.015 13.506672,9.58916092 12.445,10.7375 C11.383328,11.8858391 10.8525,13.4349902 10.8525,15.385 C10.8525,17.3350097 11.383328,18.8841609 12.445,20.0325 C13.506672,21.1808391 14.7741593,21.755 16.2475,21.755 C17.7641742,21.755 19.1941599,21.0616736 20.5375,19.675 Z M44.49,20.0325 C45.551672,18.8841609 46.0825,17.3350097 46.0825,15.385 C46.0825,13.4349902 45.551672,11.8858391 44.49,10.7375 C43.428328,9.58916092 42.1825071,9.015 40.7525,9.015 C39.2358258,9.015 37.7950068,9.74082607 36.43,11.1925 C35.0649932,12.6441739 34.0358368,14.0849928 33.3425,15.515 C34.0791704,16.9016736 35.11916,18.2883264 36.4625,19.675 C37.8058401,21.0616736 39.2358258,21.755 40.7525,21.755 C42.1825071,21.755 43.428328,21.1808391 44.49,20.0325 Z"
              id="∞"
              stroke="#222232"
              strokeWidth="2"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Sample2 = ({ style }) => <svg style={style} />

export const Sample3 = ({ style }) => <svg style={style} />



// WEBPACK FOOTER //
// ./src/assets/FeatureIcons.js